<template>
<div :style=" { backgroundColor: loginCheckComplete ? '#394BA7' : 'transparent' }">
  <div class="container">
    <div class="row justify-content-center align-items-center vh-100">
      <div class="form col-sm-5">
        <Login @update:login-check-complete="loginFunc" />
      </div>
    </div>
  </div>
</div>
</template>


<script setup lang="ts">
import Login from '@/views/Auth/components/Login.vue'
import {ref} from "vue";

const loginCheckComplete = ref(false)
const loginFunc = (val: boolean) => loginCheckComplete.value = val

</script>

<style scoped lang="scss">

</style>